import { multiFranchiseAxios } from '../axios/multiFranchiseAxios';

// Shipping Master Interfaces - Updated to match actual API response
export interface IShippingCompany {
  id: number;
  uuid: string;
  company_name: string;
  tax_id: string | null;
  contact_person: string;
  phone: string;
  email: string;
  address: string;
  service_areas: string | null;
  rate_per_km: string;
  minimum_charge: string;
  service_conditions: string | null;
  billing_type: 'monthly' | 'per_delivery' | 'contract';
  payment_terms: number;
  notes: string | null;
  status: 'active' | 'inactive' | 'suspended';
  created_at: string;
  updated_at: string;
  removed_at: string | null;
}

export interface ICreateShippingCompanyRequest {
  company_name: string;
  tax_id?: string;
  contact_person: string;
  phone: string;
  email: string;
  address: string;
  service_areas?: string;
  rate_per_km: number;
  minimum_charge: number;
  service_conditions?: string;
  billing_type: 'monthly' | 'per_delivery' | 'contract';
  payment_terms: number;
  notes?: string;
  status: 'active' | 'inactive' | 'suspended';
}

export interface IUpdateShippingCompanyRequest {
  company_name?: string;
  tax_id?: string;
  contact_person?: string;
  phone?: string;
  email?: string;
  address?: string;
  service_areas?: string;
  rate_per_km?: number;
  minimum_charge?: number;
  service_conditions?: string;
  billing_type?: 'monthly' | 'per_delivery' | 'contract';
  payment_terms?: number;
  notes?: string;
  status?: 'active' | 'inactive' | 'suspended';
}

export interface IShippingCompanyResponse {
  success: boolean;
  data: IShippingCompany[];
  message?: string;
  pagination?: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface IShippingCompanyDetailResponse {
  success: boolean;
  data: IShippingCompany;
  message?: string;
}

// API Functions - Updated to match actual response format
export const APIGetShippingCompanies = async (params?: {
  page?: number;
  limit?: number;
  status?: string;
  search?: string;
}): Promise<IShippingCompany[]> => {
  const response = await multiFranchiseAxios.get('/procurement/epod/shipping-master');
  return response.data; // API returns array directly
};

// Get only active shipping companies (shortcut endpoint)
export const APIGetActiveShippingCompanies = async (): Promise<IShippingCompany[]> => {
  const response = await multiFranchiseAxios.get('/procurement/route/shipping/list');
  // API returns { status, total, data: [...] }, so we need to extract the data array
  return response.data.data || [];
};

export const APIGetShippingCompanyById = async (uuid: string): Promise<IShippingCompany> => {
  const response = await multiFranchiseAxios.get(`/procurement/epod/shipping-master/${uuid}`);
  return response.data;
};

export const APICreateShippingCompany = async (data: ICreateShippingCompanyRequest): Promise<IShippingCompany> => {
  const response = await multiFranchiseAxios.post('/procurement/epod/shipping-master', data);
  return response.data;
};

export const APIUpdateShippingCompany = async (uuid: string, data: IUpdateShippingCompanyRequest): Promise<IShippingCompany> => {
  const response = await multiFranchiseAxios.put(`/procurement/epod/shipping-master/${uuid}`, data);
  return response.data;
};

export const APIDeleteShippingCompany = async (uuid: string): Promise<{ success: boolean; message?: string }> => {
  await multiFranchiseAxios.delete(`/procurement/epod/shipping-master/${uuid}`);
  return {
    success: true,
    message: 'Deleted successfully'
  };
};
